import React from 'react';

interface SpacerProps {
  height: string | number;  
}

const Spacer: React.FC<SpacerProps> = ({ height }) => {
  return (
    <div className='spacer' style={{ height }}></div>
  );
};

export default Spacer;
